import React from "react"; // React
import ReactDOM from "react-dom"; // React DOM
import { BrowserRouter, Route } from "react-router-dom"; // Router
import { Provider } from "react-redux"; // Redux HOC
import ReactGA from "react-ga4"; // Google Analytics
import DeviceStateManager from "./app/device_state"; // Responsive view states (mobile, table, desktop)
import { AnalyticsLogger, CrashLogger } from "./app/logger"; // Analytics and crash loggers
import * as routes from "./constants/routes"; // Routing constants
import store from "./redux"; // Redux store
import App from "./App"; // Root component
import { isMobileDevice } from "./common/utils";
import register, { unregister } from "registerServiceWorker";

// Loggers initialization
AnalyticsLogger.setUrl(window?.GeneralDeclaration?.analytics_logger_url);
CrashLogger.setUrl(window?.GeneralDeclaration?.crash_logger_url);

// Google Analytics initialization
const { REACT_APP_ANALYTICS_ID } = process.env;
REACT_APP_ANALYTICS_ID && ReactGA.initialize(REACT_APP_ANALYTICS_ID);

// Device State initialization
new DeviceStateManager(store.dispatch);

const loadBthn = () => {

  const shouldHideBthn = () => {
    const viewed = sessionStorage.getItem("viewed_bthn");
    const url = window.location.pathname;
    if (viewed || decodeURI(url).includes("/קטגוריה/") || window?.GeneralDeclaration?.hostagesTickerDisabled) {
      return true;
    }
    return false;
  };

  if (isMobileDevice() || shouldHideBthn()) return;
  if (!document.getElementById("bthn")) return;

  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://bringthemhomenow.net/1.4.0/hostages-ticker.js";
  script.setAttribute(
    "integrity",
    "sha384-xAHoWHwIZKxH06pyBcjGhuhdEyPaKlSDsFNJN1vH1+DvW6K8K6A10GeSGLKNjPsp"
  );
  script.setAttribute("crossorigin", "anonymous");
  document.getElementsByTagName("head")[0].appendChild(script);
  sessionStorage.setItem("viewed_bthn", "true");
};

const removebthn = () => {
  if (document.getElementById("closeBthn"))
    document.getElementById("closeBthn").click();
};

ReactDOM.render(
  <BrowserRouter basename="/">
    <Route
      path="/"
      render={({ location, history }) => {
        // Handle analytics reporting (old implementation)
        let report_location = location.pathname;
        history.listen(removebthn);
        if (location.pathname === "/") {
          report_location = routes.home;
        }

        if (typeof window.gtag === "function") {
          window.gtag("config", "AW-929315175", {
            page_path: report_location,
          });
        }

        if (typeof window.fbq === "function") {
          window.fbq("track", "PageView");
        }
        return null;
      }}
    />

    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

try {
  register();
  loadBthn();
} catch (e) {
  console.error(e);
}
